import type {IdentityVerificationSchema} from '../identityVerification';

export const getBiomatchResultData = (state: IdentityVerificationSchema) =>
  state.biomatchResultData;
